import { toast } from "react-toastify";

export default function Notify(toastType, message) {
  toast[toastType](message, {
        position: toast.POSITION.BOTTOM_LEFT,
        autoClose: 2000,
      });
}
